import { render, staticRenderFns } from "./wizard-form.vue?vue&type=template&id=4fa59d10&"
import script from "./wizard-form.vue?vue&type=script&lang=js&"
export * from "./wizard-form.vue?vue&type=script&lang=js&"
import style0 from "./wizard-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports